export interface FrameConfig {
	filename: string | null;
	interval: number;
	rotation: number;
	verticalFlip: boolean;
	horizontalFlip: boolean;
	width: number;
	height: number;
	offsetX: number;
	offsetY: number;
	character: string | null;
	foreground: string | null;
	background: string | null;
}

export function parseFrameConfig(json: any): FrameConfig {
	if (json.interval === undefined) {
		throw new Error("FrameConfig: interval is required");
	}

	return {
		filename: json.filename ?? null,
		interval: json.interval,
		rotation: json.rotation ?? 0,
		verticalFlip: json.verticalFlip ?? false,
		horizontalFlip: json.horizontalFlip ?? false,
		width: json.width ?? 1.0,
		height: json.height ?? 1.0,
		offsetX: json.offsetX ?? 0.0,
		offsetY: json.offsetY ?? 0.0,
		character: json.character ?? null,
		foreground: json.foreground ?? null,
		background: json.background ?? null,
	};
}
